
<style scoped>
.table-container {
    position: relative;
    overflow: scroll;
}
.table-container-loading {
    position: relative;
    overflow: scroll;
    opacity: 0.2;
}
.atd-revenue-report {
    display: flex;
    justify-content: space-between;
}
.table-container {
    position: relative;
    overflow: scroll;
}
tr th:first-child {
    box-shadow: 1px 0 2px -2px #888;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 15px;
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    background: #ffffff;
}

thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
}

tbody th {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
}

thead th:first-child {
    background: #ffffff !important;
    box-shadow: 1px 0 2px -2px #888;
    left: 0;
    z-index: 1;
}

thead th:last-child {
    background: #ffffff !important;
    box-shadow: -2px 0 2px -2px #888;
    right: 0;
    z-index: 1;
}

tr td:first-child {
    box-shadow: 1px 0 2px -2px #888;
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 15px;
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    background: #ffffff;
}

tr td:last-child {
    box-shadow: -2px 0 2px -2px #888;
    content: "";
    top: 0;
    bottom: 0;
    width: 15px;
    right: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    background: #ffffff;
}
</style>

<template>

<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h1>Revenue</h1>
                <span id="downloadcon"></span>

            </div>
            <div class="box-body">

                <div v-if="impressionRevenueTableData.length>0">
                    <el-row :gutter=24>
                        <el-col :span=12>
                              <div class="grid-content">
                            <JsonCSV :advancedOptions=tsting() class="btn btn-default atd-report-download" :data="csvData" :name=reportName style="background-color:#0da1f5; border:none;-moz-box-shadow:2px 2px 4px #000000;-webkit-box-shadow:2px 2px 4px #000000;box-shadow:2px 2px 4px #000000;" v-if="impressionRevenueReportData.length>0">
                                <i style="color: #fff; font-weight: bold; " class="iconsmind-Data-Download"></i>
                                <div class="atd-title-text">Download</div>
                            </JsonCSV>
                             

                              
                                <!-- <span v-for="(domain, index) in domainName" :key="index">
                                    <span v-if="domain.domain_id == domainId ">
                                        {{domainNameFormatter(domain.domain_name)}}
                                    </span>
                                </span> -->
                               

                            </div>
                        </el-col>
                        <el-col span="12">
                            <div class="grid-content">
                                <div style="float:right">
                                <!-- <h1><i class="iconsmind-Calendar-4 mr-3" style="vertical-align:sub;" /> -->
                                    <span class="align-middle d-inline-block" style="width:150px ">
                                        <date-picker :lang='lang' style="min-width:180px;" :shortcuts="shortcuts" mode="range" v-model="selectedValueRange" range @change="getRevenueImpressionReports()" :not-after='endDate'></date-picker>
                                    </span>
                                <!-- </h1> -->
                                </div>
                            </div>

                        </el-col>
                        
                    </el-row>
                    <el-row :gutter=24>
                        <!-- <el-col> -->
                            <!-- <el-row> -->

                                <el-col :span="24">

                                    <div class="table-container" v-bind:class = "(isLoading)?'table-container-loading':'table-container'">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <el-row style="width: 100px;" class="text-center text-uppercase">
                                                            <el-col :span=12>
                                                                <span>Date</span>
                                                            </el-col>
                                                        </el-row>
                                                    </th>
                                                    <th v-for="(bidder, index) in tableBidderName" :key="index">
                                                        <el-row style="width: 240px;">
                                                          <el-col :span=24>
                                                                <el-col :span=24 class="text-center text-uppercase">
                                                                    <span>{{bidder}}</span>
                                                                </el-col>
                                                                <el-col :span=24 class="atd-revenue-report ">
                                                                    <el-col :span=9>
                                                                        <span>Impressions</span>
                                                                    </el-col>
                                                                    <el-col :span=9>
                                                                        <span>Revenue</span>
                                                                    </el-col>
                                                                    <el-col :span=6>
                                                                        <span>eCPM</span>
                                                                    </el-col>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </th>
                                                    <th style="position: sticky;top: 0;">
                                                        <el-row style="width: 220px;">
                                                           <el-col :span=24 >
                                                                <el-col :span=24 class="text-center text-uppercase">
                                                                    <span>Total</span>
                                                                </el-col>
                                                                <el-col :span=24>
                                                                    <el-col :span=10>
                                                                        <span>Impressions</span>
                                                                    </el-col>
                                                                    <el-col :span=8>
                                                                        <span>Revenue</span>
                                                                    </el-col>
                                                                    <el-col :span=4>
                                                                        <span>eCPM</span>
                                                                    </el-col>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(revenue, parentIndex) in impressionRevenueTableData" :key="parentIndex">
                                                    <td>
                                                        <span class="font-weight-medium">{{dateFormater(revenue.date)}}</span>
                                                    </td>
                                                    <td v-for="(bidder, childindex) in tableBidderName" :key="childindex">
                                                        <el-row style="width: 240px;">
                                                            <el-col :span="24">
                                                                <el-col :span="10">
                                                                    <span v-if="addCommas(getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression')) == 0">-</span>
                                                                    <span v-else>{{addCommas(getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression'))}}</span>
                                                                </el-col>
                                                                <el-col :span="8">

                                                                    <span v-if="getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue')!=0">$</span>
                                                                    <span v-if="addCommas(getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue')) == 0">-</span>
                                                                    <span v-else>{{addCommas(getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue'))}}</span>
                                                                </el-col>
                                                                <el-col :span="4">
                                                                    <span v-if="getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue')!=0">$</span>
                                                                    <span v-if="getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm') == 0">-</span>
                                                                    <span v-else>{{getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm')}}</span>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </td>
                                                    <td>
                                                        <el-row style="width: 220px;">
                                                            <el-col :span="24">
                                                                <el-col :span="10">
                                                                    <span v-if="addCommas(revenue.impression) == 0">-</span>
															<span v-else>{{addCommas(revenue.impression)}}</span>
                                                                    <!-- <span>{{addCommas(revenue.impression)}}</span> -->
                                                                </el-col>
                                                                <el-col :span="8">
                                                                    <span v-if="revenue.revenue!=0">$</span>
																<span v-if="addCommas(revenue.revenue) == 0">-</span>
																<span v-else>{{addCommas(revenue.revenue)}}</span>
                                                                </el-col>
                                                                <el-col :span="4">
                                                                    <span v-if="revenue.ecpm!=0">$</span>
																<span v-if="revenue.ecpm == 0">-</span>
																<span v-else>{{revenue.ecpm}}</span>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                <tr>
                                                    <th>
                                                        <el-row style="width: 100px;">
                                                            <el-col :span=24>
                                                                <span>Total</span>
                                                            </el-col>
                                                        </el-row>
                                                    </th>
                                                    <td v-for="(bidder, childindex) in tableBidderName" :key="childindex">
                                                        <el-row style="width: 240px;">
                                                            <el-col :span=24>
                                                                <el-col :span=10>
                                                                    <span>{{addCommas(getColumnTotal(bidder,'impression'))}}</span>
                                                                </el-col>
                                                                <el-col :span=8>
                                                                    <span>$</span>
                                                                    <span>{{addCommas(getColumnTotal(bidder,'revenue'))}}</span>
                                                                </el-col>
                                                                <el-col :span=4>
                                                                    <span>$</span>
                                                                    <span>{{getColumnCPM(bidder)}}</span>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </td>
                                                    <td>
                                                        <el-row style="width: 220px;">
                                                           <el-col :span=24>
                                                                <el-col :span=10>
                                                                    <span>{{addCommas(getColumnTotal('total','impression'))}}</span>
                                                                </el-col>
                                                                <el-col :span=8>
                                                                    <span><span>$</span>{{addCommas(getColumnTotal('total','revenue'))}}
                                                                    </span>
                                                                </el-col>
                                                                <el-col :span=4>
                                                                    <span><span>$</span>{{getColumnCPM('total')}}
                                                                    </span>
                                                                </el-col>
                                                            </el-col>
                                                        </el-row>
                                                    </td>
                                                </tr>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                </el-col>
                            <!-- </el-row> -->
                        <!-- </el-col> -->
                    </el-row>
                </div>
                <div class="text-center d-flex justify-content-between" v-else>
                    <div class="loading"></div>
                </div>
            </div>
        </div>
    </section>

</div>
</template>

<script>
import axios from "axios";
import VueAxios from "vue-axios";

// import ReportsChart from 'components/ReportsChart.vue';

// import {
//     mapGetters,
//     mapMutations,
//     mapActions
// } from "vuex";
import JsonCSV from "vue-json-csv";
import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
    name: "Revenue",
    data() {
        return {
            isLoading: false,
            publisherId: undefined,
            domainId: undefined,
            // domainId: (this.$route.params.domainId) ? parseInt(this.$route.params.domainId) : undefined,
            impressionRevenueReportData: [],
            impressionRevenueTableData: [],
            selectedValueRange: [new Date(), new Date()],
            selectedStartDate: undefined,
            selectedEndDate: undefined,
            today: undefined,
            endDate: undefined,
            startDate: undefined,
            tableBidderName: [],
            csvData: [],
            allDomains: [],
            reportName:
                "AutomatadReports_" +
                moment(new Date()).format("YYYY-MM-DD") +
                ".csv",
            domainName: [],
            lang: {
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days",
                ],
                placeholder: {
                    date: "Select Date",
                    dateRange: "Select Date Range",
                },
            },
            shortcuts: [
                {
                    text: "Month-to-date",
                    onClick: () => {
                        this.selectedValueRange = [
                            new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                1
                            ),
                            new Date(),
                        ];
                        this.getRevenueImpressionReports();
                    },
                },
                {
                    text: "Last Month",
                    onClick: () => {
                        this.selectedValueRange = [
                            new Date(
                                new Date().getFullYear(),
                                new Date().getMonth() - 1,
                                1
                            ),
                            new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                0
                            ),
                        ];
                        this.getRevenueImpressionReports();
                    },
                },
                {
                    text: "Last Six Month",
                    onClick: () => {
                        this.selectedValueRange = [
                            new Date(
                                new Date().getFullYear(),
                                new Date().getMonth() - 6,
                                1
                            ),
                            new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                0
                            ),
                        ];
                        this.getRevenueImpressionReports();
                    },
                },
            ],
            totalColECPM: 0,
            totalColImpression: 0,
            totalColRevenue: 0,
        };
    },
    components: {
        // ReportsChart,
        JsonCSV,
        DatePicker,
    },
    computed: {
        // ...mapGetters({
        //     currentUser: "currentUser",
        // })
    },
    created() {
        this.domainId = parseInt(this.$route.params.domid);

        //console.log("this.domainId in created", this.domainId,"typeof",typeof this.domainId);
        this.publisherId = parseInt(this.$route.params.pubid);
        //console.log(" this.publisherId in created", this.publisherId,"typeof",typeof this.publisherId);
    },
    mounted() {
        // this.publisherId = this.$routes.params.pubid;
        this.publisherId = this.$route.params.pubid;
        //console.log(" this.publisherId in mounted", this.publisherId);

        //console.log("@@publisherId", this.publisherId);
        // this.publisherId = this.publisherId = (this.currentUser) ? this.currentUser[0]['id'] : JSON.parse(localStorage.getItem('publisher'))[0]['id'];
        this.today = new Date();
        this.endDate = new Date();
        var firstStartDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
        );
        this.startDate = new Date(
            firstStartDate.setDate(firstStartDate.getDate() - 2)
        );

        this.selectedValueRange[0] = this.startDate;
        this.selectedValueRange[1] = this.endDate;
        this.getBiddernames();
        this.getDomain(this.domainId);
        this.getRevenueImpressionReports();
        this.getPublisherDomainList();
    },
    methods: {
        addCommas(
            number,
            minDecimalPlaces = 0,
            maxDecimalPlaces = Math.max(3, minDecimalPlaces)
        ) {
            const options = {};
            options.maximumFractionDigits = maxDecimalPlaces;
            options.minimumFractionDigits = minDecimalPlaces;
            return Intl.NumberFormat("en-US", options).format(number);
        },
        tsting() {
            return {
                transform: this.transformEachLine,
            };
        },
        transformEachLine(value, columnNumber) {
            if (value == "") {
                value = 0;
            }
            return value;
        },
        getDomain(domain) {
            axios
                .post(BASE_URL + "reports/v1/pub-get-dash-info/", {
                    publisherId: this.publisherId,
                })
                .then((response) => {
                    if (response.data.status) {
                        if (domain == null) {
                            this.allDomains = "".concat(
                                response.data.data.map(
                                    (k) => " " + k.domain_name
                                )
                            );
                        } else {
                            this.allDomains = "".concat(
                                response.data.data.filter((k) => {
                                    return domain == k.domain_id;
                                })[0].domain_name
                            );
                        }
                        return this.allDomains;
                    }
                })
                .catch((e) => {
                    //console.log(e);
                });
        },
        getColumnCPM(bidder) {
            var revenue = 0;
            var impression = 0;
            var arr = 0;

            if (bidder == "total") {
                this.impressionRevenueReportData.map((k) => {
                    if (k.hasOwnProperty("impression")) {
                        revenue += k["revenue"];
                        impression += k["impression"];
                    }
                    // var arr1=(revenue/impression)*1000
                    // this.totalColECPM=(Math.round((arr1+ Number.EPSILON )*100))/100
                });
            } else {
                this.impressionRevenueReportData.map((k) => {
                    if (k.bidderImpressionRevenue.hasOwnProperty(bidder)) {
                        revenue += k.bidderImpressionRevenue[bidder]["revenue"];
                        impression +=
                            k.bidderImpressionRevenue[bidder]["impression"];
                    }
                });
            }

            if (impression != 0) {
                arr = (revenue / impression) * 1000;
                return Math.round((arr + Number.EPSILON) * 100) / 100;
            }
            return arr;
        },
        fillMissingObj(object) {
            var defaults = {};
            var list = [];

            function addToList(obj) {
                // Create our entry backed by the defaults
                var entry = Object.create(defaults);

                // Loop through the new object's keys...
                Object.keys(obj).forEach(function (key) {
                    // ...adding a default if it's a new key
                    if (!defaults.hasOwnProperty(key)) {
                        defaults[key] = "default for " + key;
                    }
                    // ...and grabbing the value
                    entry[key] = obj[key];
                });

                // Put it on the list
                list.push(entry);
            }

            addToList({
                a: "a0",
                b: "b0",
            }); // Has a and b
            addToList({
                a: "a1",
                c: "c1",
            }); // Has a and c
            addToList({
                b: "b2",
                d: "d2",
            }); // Has b and d

            list.forEach(function (entry, index) {
                snippet.log("Object #" + index + ":");
                Object.keys(defaults).forEach(function (key) {
                    snippet.log(key + " = " + entry[key]);
                });
            });
        },
        dict_reverse(obj) {
            var new_obj = {};
            var rev_obj = ["impression", "revenue", "ecpm"];
            rev_obj.forEach(function (i) {
                new_obj[i] = obj[i];
            });
            return new_obj;
        },
        reverseObject(object) {
            //console.log(object)
            var newObject = {};
            var keys = [];

            for (var key in object) {
                keys.push(key);
            }

            for (var i = keys.length - 1; i >= 0; i--) {
                var value = object[keys[i]];
                newObject[keys[i]] = value;
            }
            return newObject;
        },
        getColumnTotal(bidder, property) {
            var arr = 0;

            if (bidder == "total") {
                this.impressionRevenueReportData.map((k) => {
                    if (k.hasOwnProperty(property)) {
                        arr += k[property];
                    }
                });
                // if(property=='revenue'){
                // 		this.totalColRevenue=arr
                // 	}else{
                // 		this.totalColImpression=arr
                // 	}
            } else {
                this.impressionRevenueReportData.map((k) => {
                    if (k.bidderImpressionRevenue.hasOwnProperty(bidder)) {
                        arr += k.bidderImpressionRevenue[bidder][property];
                    }
                });
            }
            if (property == "revenue") {
                return Math.round((arr + Number.EPSILON) * 100) / 100;
            }
            return arr;
        },
        getRevenueImpressionReports() {
            let self = this;
            var diff =
                this.selectedValueRange[1].getTime() -
                this.selectedValueRange[0].getTime();
            var maxDate = Math.floor(diff / (1000 * 60 * 60 * 24));
            //console.log('kk', this.selectedValueRange[0].getTime())
            if (maxDate <= 186) {
                this.isLoading = true;
                axios
                    .post(
                        BASE_URL + "reports/v1/get-impression-revenue-reports/",
                        {
                            publisherId: this.publisherId,
                            domainId: this.domainId,
                            selectedDateRange: {
                                start: moment
                                    .utc(this.selectedValueRange[0])
                                    .local()
                                    .format("DD/MM/YYYY"),
                                end: moment
                                    .utc(this.selectedValueRange[1])
                                    .local()
                                    .format("DD/MM/YYYY"),
                            },
                        }
                    )
                    .then((response) => {
                        this.isLoading = false;
                        if (response.data.status) {
                            this.impressionRevenueReportData =
                                response.data.data;
                            this.impressionRevenueTableData =
                                this.impressionRevenueReportData.reverse();
                            this.getDomain(this.domainId);
                            var bidderTotal = {};
                            var sites = {};
                            var dateRange = {};
                            var count = 0;
                            this.csvData = this.impressionRevenueReportData.map(
                                (
                                    {
                                        bidderImpressionRevenue,
                                        currency,
                                        ...attrs
                                    },
                                    index
                                ) => {
                                    var l = {};
                                    for (var i in this.tableBidderName) {
                                        let bidr = this.tableBidderName[i];
                                        let bidObj =
                                            bidderImpressionRevenue.hasOwnProperty(
                                                bidr
                                            )
                                                ? this.dict_reverse(
                                                      bidderImpressionRevenue[
                                                          bidr
                                                      ]
                                                  )
                                                : this.dict_reverse({
                                                      impression: 0,
                                                      ecpm: 0,
                                                      revenue: 0,
                                                  });
                                        for (var m in bidObj) {
                                            if (m == "revenue" || m == "ecpm") {
                                                l[bidr + " " + m + "($)"] =
                                                    bidderImpressionRevenue.hasOwnProperty(
                                                        bidr
                                                    )
                                                        ? this.addCommas(
                                                              bidderImpressionRevenue[
                                                                  bidr
                                                              ][m]
                                                          )
                                                        : 0;
                                            } else {
                                                l[bidr + " " + m] =
                                                    bidderImpressionRevenue.hasOwnProperty(
                                                        bidr
                                                    )
                                                        ? this.addCommas(
                                                              bidderImpressionRevenue[
                                                                  bidr
                                                              ][m]
                                                          )
                                                        : 0;
                                            }
                                        }
                                    }

                                    for (var i in bidderImpressionRevenue) {
                                        for (var m in this.dict_reverse(
                                            bidderImpressionRevenue[i]
                                        )) {
                                            if (count == 0) {
                                                sites[i + " " + m] =
                                                    this.allDomains;
                                                dateRange[i + " " + m] =
                                                    moment(
                                                        this
                                                            .selectedValueRange[0]
                                                    ).format("YYYY-MM-DD") +
                                                    " to " +
                                                    moment(
                                                        this
                                                            .selectedValueRange[1]
                                                    ).format("YYYY-MM-DD");
                                            }
                                            count += 1;
                                            if (m == "revenue" || m == "ecpm") {
                                                if (m == "revenue") {
                                                    bidderTotal[
                                                        i + " " + m + "($)"
                                                    ] = this.addCommas(
                                                        this.getColumnTotal(
                                                            i,
                                                            m
                                                        )
                                                    );
                                                } else {
                                                    bidderTotal[
                                                        i + " " + m + "($)"
                                                    ] = this.getColumnCPM(i);
                                                }
                                            } else {
                                                bidderTotal[i + " " + m] =
                                                    this.addCommas(
                                                        this.getColumnTotal(
                                                            i,
                                                            m
                                                        )
                                                    );
                                            }
                                        }
                                    }

                                    return Object.assign(
                                        {
                                            Date: moment(attrs.date).format(
                                                "ll"
                                            ),
                                        },
                                        l,
                                        {
                                            " Ad Impressions": attrs.impression,
                                            "Estimated Revenue($)":
                                                attrs.revenue,
                                            "ECPM($)": attrs.ecpm,
                                        }
                                    );
                                }
                            );

                            var dateT = "";
                            var siteT = "";

                            if (Object.keys(dateRange).length == 0) {
                                dateT =
                                    moment(this.selectedValueRange[0]).format(
                                        "YYYY-MM-DD"
                                    ) +
                                    " to " +
                                    moment(this.selectedValueRange[1]).format(
                                        "YYYY-MM-DD"
                                    );
                            } else {
                                dateT = "";
                            }

                            if (Object.keys(sites).length == 0) {
                                siteT = this.allDomains;
                            } else {
                                siteT = "";
                            }
                            // //console.log(this.csvData)

                            this.csvData = [
                                ...this.csvData,
                                Object.assign(
                                    {
                                        Date: "Total",
                                    },
                                    bidderTotal,
                                    {
                                        " Ad Impressions": this.addCommas(
                                            this.getColumnTotal(
                                                "total",
                                                "impression"
                                            )
                                        ),
                                        "Estimated Revenue($)": this.addCommas(
                                            this.getColumnTotal(
                                                "total",
                                                "revenue"
                                            )
                                        ),
                                        "ECPM($)": this.getColumnCPM("total"),
                                    }
                                ),
                                {
                                    Date: "",
                                    " Ad Impressions": "",
                                    "Estimated Revenue($)": "",
                                },
                                Object.assign(
                                    {
                                        Date: "Domain:",
                                    },
                                    sites,
                                    {
                                        " Ad Impressions": siteT,
                                        "Estimated Revenue($)": "",
                                    }
                                ),
                                Object.assign(
                                    {
                                        Date: "Date Range:",
                                    },
                                    dateRange,
                                    {
                                        " Ad Impressions": dateT,
                                        "Estimated Revenue($)": "",
                                    }
                                ),
                            ];
                        }
                    })
                    .catch((e) => {
                        //console.warn(e);
                    });
            } else {
                //console.log("@@ less then 33 days")

                self.$notify({
                    title: "warning",
                    message:
                        "Selected Date range should be lesser than or equal to 6 month.",
                    type: "warning",
                });

                // this.selectedValueRange = [
                //     '',
                //     ''
                // ]
                // this.getRevenueImpressionReports()
            }
        },
        domainNameFormatter(domainName) {
            return domainName
                .replace("http://", "")
                .replace("https://", "")
                .replace("/", "");
        },
        getPublisherDomainList() {
            axios
                .post(BASE_URL + "reports/v1/pub-get-dash-info/", {
                    publisherId: this.publisherId,
                })
                .then((response) => {
                    if (response.data.status) {
                        this.domainName = response.data.data;
                    }
                })
                .catch((e) => {
                    this.unauthorizedAccess();
                });
        },
        getBiddernames() {
            axios
                .post(BASE_URL + "reports/v1/get-bidder-names/", {
                    publisherId: this.publisherId,
                    domainId: this.domainId,
                })
                .then((response) => {
                    if (response.data.status) {
                        this.tableBidderName = response.data.data;
                    }
                })
                .catch((e) => {
                    //console.warn(e);
                });
        },
        getBidderTotalRevenueAndImpression(
            idx,
            bidderNm,
            impresssionOrRevenue
        ) {
            var impressionRevenue = 0;
            if (
                this.impressionRevenueReportData[idx][
                    "bidderImpressionRevenue"
                ].hasOwnProperty(bidderNm)
            ) {
                impressionRevenue =
                    this.impressionRevenueReportData[idx][
                        "bidderImpressionRevenue"
                    ][bidderNm][impresssionOrRevenue];
                // //console.log(impressionRevenue)
            }
            return impressionRevenue;
        },
        dateFormater(dt) {
            return dt.toString().replace("T00:00:00", "");
        },
    },
};
</script>



// WEBPACK FOOTER //
// reports.vue?3855bcfc